import { Array } from '@common/Array/Array'

import type { TOs } from '../definitions'
import { OSS } from '../definitions'

/**
 * Os elkérése, userAgent alapján.
 * @param os - Os típusa.
 */
export default function getOs (os: string | undefined): TOs {
  if (Array.includes(OSS, os)) {
    return os as TOs
  }

  return undefined
}
